export default function ensureArray(maybeArray) {
    return !maybeArray
        ? []
        : Array.isArray(maybeArray)
            ? maybeArray
            : [maybeArray];
}
